import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError, receiveSuccess } from '../../store/actions/notificationAction';

import awbRemote from '../../api/awbRemote'

import PoDModal from './PoDModal';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import РroofOfDelivery from '../../models/ProofOfDelivery';

import { handlePrintProofOfDelivery } from '../../utils/printing';
import validation from '../../utils/validation';
import { getGhaInfo } from '../../store/actions/ghaAction';
import GhaModel from '../../models/Gha';
import User from '../../models/User';
import poRequestHandler from '../../api/pickupOrderRemote';

interface PoDModalState {
  poD: Array<РroofOfDelivery>;
  eMail: string;
  eMailError: boolean;
  goodsValue: boolean;
};

interface PoDModalProps {
  isModalOpen: boolean;
  code: string;
  number: string;
  version: number;
  user: User;
  getGhaInfo: Function;
  receiveError: (error: ResponseError) => void;
  receiveSuccess: (message: string) => void;
  handleCloseModal: (modalType: string) => void;
  gha: GhaModel;
  userRole?: string;
  orderNumber?: string;
}

class PoDModalContainer extends Component<PoDModalProps, PoDModalState > {

  state={
    poD: [],
    eMail: '',
    eMailError: false,
    goodsValue: false
  }

  getGha = (): void => {
    this.props.getGhaInfo(this.props.user.gha_id);
  };

  componentDidMount () {
    
    awbRemote.getAwbPoD(this.props.code, this.props.number, this.props.version).then((resp: ApiResponse<Array<РroofOfDelivery>>) => {

      const poD: Array<РroofOfDelivery> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (poD) {
        this.setState({ poD });
        this.getGoodsValue();
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
    
  };

  handleChangeMail = (event: any): void => {

    this.setState({ eMail: event.target.value });
  }

  getGoodsValue = (): void => {
    if(this.props.orderNumber) {
      poRequestHandler.getGoodsDeclaration(this.props.orderNumber).then((resp: ApiResponse<{dangerous_goods: boolean}>) => {
      const value: { dangerous_goods: boolean } | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (value) {
        this.setState({ goodsValue: value.dangerous_goods });
      }
  
      if (error) {
        this.props.receiveError(error);
      };
      });
    }
    
  }

  printProofOfDelivery = (): void => {

    const awbCode: string = this.props.code;
    const awbNumber: string = this.props.number;

    if (awbCode && awbNumber) {
      handlePrintProofOfDelivery('pod', awbCode, awbNumber, this.props.version);
    };
  }

  sendProofOfDelivery = (): void => {

    const email: string = this.state.eMail;
    const awbCode: string = this.props.code;
    const awbNumber: string = this.props.number;
    const emailValid: boolean = validation.validateEmail(email);

    if (emailValid && awbCode && awbNumber) {

      awbRemote.sendProofOfDeliveryEmail(awbCode, awbNumber, this.props.version, email).then((resp: ApiResponse<boolean>) => {

        const sent: boolean | undefined = resp.success;
        const error: ResponseError | undefined = resp.error;

        if (sent) {
          this.setState({ eMailError: false });
          this.props.receiveSuccess(`Proof Of Delivery sent successfully to: ${email}`);
        }

        if (error) {
          this.props.receiveError(error);
        };
      });

    } else {

      this.setState({ eMailError: true });
    }
  }

  render() {

    return (
      <PoDModal 
        modalOpen={ this.props.isModalOpen }
        poD={ this.state.poD }
        handleClose={ this.props.handleCloseModal }
        eMail={ this.state.eMail }
        eMailError={ this.state.eMailError }
        handleChangeMail={ this.handleChangeMail }
        awb={ `${this.props.code}-${this.props.number}` }
        sendProofOfDelivery={ this.sendProofOfDelivery }
        printProofOfDelivery={ this.printProofOfDelivery }
        userRole={ this.props.userRole }
        gha={ this.props.gha }
        goodsValue={ this.state.goodsValue }
      />
    );
  };
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    gha: state.ghaInfo
  }
}

const mapDispatchToProps = (dispatch: Function) => {
    return {
      receiveError: (error: ResponseError) => dispatch(receiveError(error)),
      receiveSuccess: (message: string) => dispatch(receiveSuccess(message)),
      getGhaInfo: (ghaId: number) => dispatch(getGhaInfo(ghaId))
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(PoDModalContainer);